import './setup';
import React from 'react';
import ReactDOM from 'react-dom';
import { Wrapper } from 'dot-design-system';
import StoreProviderContainer from './store/StoreProviderContainer';
import AdminAppContainer from './admin/AdminAppContainer';

const root = document.getElementById('dot-press-admin-root');
if (root) {
	ReactDOM.render(
		<StoreProviderContainer>
			<Wrapper
				css={`
					*,
					*:after,
					*:before {
						box-sizing: border-box;
					}
				`}
			>
				<AdminAppContainer />
			</Wrapper>
		</StoreProviderContainer>,
		root
	);
}
